import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IconButton, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { s3baseUrl } from "../../config/config";
import { ReactVideoDurationPlayer } from "src/components";
import { useSnackbar } from "notistack";
import {
  StudySessionRecordingDetailApi,
  LessonRecordingDetail,
} from "../../DAL/Programmes/Programmes";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { Icon } from "@iconify/react";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function StudySessionRecordingDetail(props) {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [recordingData, seRecordingData] = React.useState({});
  const handleNavigate = () => {
    navigate(-1);
  };
  const { handleVideoList } = useContentSetting();
  const [videoProgressData, setVideoProgressData] = useState([]);

  const getSessionRecordingDetail = async () => {
    setIsLoading(true);
    console.log(params.recording_slug, "params.recording_slug");
    const result = await StudySessionRecordingDetailApi(params.recording_slug);
    if (result.code === 200) {
      console.log(result, "resultresultresultresultresultresultresultresult");
      let data = [
        {
          recording_id: result.study_session_recording?._id,
          video_duration: result.study_session_recording?.video_duration,
          total_video_duration:
            result.study_session_recording?.total_video_duration,
          is_complete: result.study_session_recording?.is_complete,
        },
      ];
      setVideoProgressData(data);
      handleVideoList(data);
      localStorage.setItem("video_list", JSON.stringify(data));
      localStorage.setItem("video_type", "study_section_recording");

      seRecordingData(result.study_session_recording);
      console.log(
        result.study_session_recording,
        "result.study_session_recording"
      );
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      navigate(`/programs`);
    }
  };

  useEffect(() => {
    getSessionRecordingDetail();
  }, [params.recording_slug]);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  console.log(recordingData, "recordingData");
  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-12">
          <IconButton
            className="back-screen-button"
            onClick={() => handleNavigate()}>
            <ArrowBackIcon />
          </IconButton>
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12">
          <h1 className="programmes-heading">
            {htmlDecode(recordingData.title)}
          </h1>
        </div>
      </div>
      <div className="row media-margin">
        <div className="col-12">
          <ReactVideoDurationPlayer
            url={recordingData.video_url}
            type={"study_section_recording"}
            value={recordingData}
            setVideoProgressData={setVideoProgressData}
            videoProgressData={videoProgressData}
          />
        </div>
        <div className="col-12 text-end">
          {recordingData.is_complete ? (
            <Icon
              icon="mdi:tick-circle"
              width={30}
              height={30}
              color="primary"
            />
          ) : (
            // <Icon
            //   icon="clarity:clock-solid"
            //   width={30}
            //   height={30}
            //   color="primary"
            // />
            <></>
          )}
        </div>
        <div className="col-12 section-space">
          <p
            dangerouslySetInnerHTML={{
              __html: recordingData.detailed_description,
            }}></p>
        </div>
      </div>
    </div>
  );
}

export default StudySessionRecordingDetail;
